<template>
  <div class="col-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            {{ $lang.Determine_the_level_of_access }}
            <strong v-if="role"
              >({{ role ? role.caption : ""
              }}{{ role ? `->${role.parent_caption}` : "" }})</strong
            >
          </div>
          <LoadingSpinner :loading="loadingItem" :text="loadingSpinnerText" />
          <div v-show="!loadingItem">
            <div v-if="items.length">
              <TableRole
                :items="items"
                :fields="fields"
                :roleCode="roleCode"
              />
            </div>
            <div class="text-center" v-else>
              <h4>{{ $lang.notRecordExist }}</h4>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import TableRole from "./tableRole";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { generateApiUrl } from "@/shared/utils";
import { pathOr } from "ramda";

export default {
  name: "assign-role-permissions",
  components: {
    TableRole,
    LoadingSpinner,
  },
  data() {
    return {
      roleCode: this.$route.params.id,
      loadingItem: false,
      role: null,
      fields: ["منبع", "خواندنی", "ویرایش", "کامل", "دسترسی به داده‌ها"],
      items: [],
      loadingSpinnerText: this.$lang.receiving_data,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    generateApiUrl,
    async fetchData() {
      try {
        this.loadingSpinnerText = this.$lang.receiving_data;
        this.loadingItem = true;
        const url = generateApiUrl(
          ["resources", "role_permissions"],
          [this.roleCode]
        );
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.role = pathOr(null, ["role"], data);
        const permissionGroups = pathOr([], ["permission_groups"], data);
        this.items = permissionGroups.map((x, index) => {
          let parent_acl_role_all = [
            {
              text: "محدود",
              value: "self",
              tooltip: x.acl_self_description,
            },
            {
              text: "همه",
              value: "all",
              tooltip: x.acl_all_description,
            },
          ];
          let parent_acl_role_self = [
            {
              text: "محدود",
              value: "self",
              tooltip: x.acl_self_description,
            },
          ];
          return {
            id: index + 1,
            name: x.permission_caption,
            parent_acl_role: x.parent_acl_role,
            // به دلیل این که می خواستیم دیتا اول خواندنی تا کامل باشد این گونه شد
            permissions: x.permissions.reverse(),
            acl_role_options:
              x.parent_acl_role == "all"
                ? parent_acl_role_all
                : parent_acl_role_self,
            acl_role:
              x.permissions[0] && x.permissions[0].acl_role
                ? x.permissions[0].acl_role
                : "self",
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loadingItem = false;
      }
    },
  },
};
</script>
